<div style="height:100dvh;">
  <app-video-call [identifier]="eventId"></app-video-call>
</div>